import { React, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';
import {
  Typography,
  Container,
  Divider,
  Card,
  CardContent,
  Grid,
} from '@mui/material';
import { TrendingDown, TrendingUp } from '@mui/icons-material';

const GoldPrice2Form = ({ data, buy }) => {
  const isPositiveChange = data?.price?.change?.compare_previous >= 0;
  const [goldPrice, setGoldprice] = useState(false);
  const [reload, setReload] = useState(false);
  useEffect(() => {
    try {
      axios.get('https://psu-thaigold.eappsoft.net/latest').then((res) => {
        setGoldprice(res.data?.response);
      });
    } catch (error) {
      console.error('Error', error?.message);
    }
    return () => {};
  }, [reload]);
  const GoldBarSell = goldPrice?.price?.gold_bar?.sell;
  const GoldBarSellfull = parseFloat(
    (GoldBarSell || '').toString().replace(/,/g, ''),
  );
  const goldBuybackbasic = (GoldBarSellfull - 100) * 0.98;
  const goldBuybackGramRaw = goldBuybackbasic / 15.16;
  let goldBuybackGram = '';
  if (goldBuybackGramRaw !== undefined && !isNaN(goldBuybackGramRaw)) {
    const decimal = goldBuybackGramRaw % 1;
    if (decimal <= 0.5) {
      goldBuybackGram = Math.floor(goldBuybackGramRaw);
    } else {
      goldBuybackGram = Math.ceil(goldBuybackGramRaw);
    }
  }
  const goldBuybackBath = (goldBuybackGram * 15.16).toFixed(2);
  const sellPrice =
    parseFloat(
      (goldPrice?.price?.gold_bar?.sell || '').toString().replace(/,/g, ''),
    ) * 0.95;

  const goldBuyback = goldPrice?.price?.gold?.buy / 15.16;

  return (
    <Container maxWidth="lg" className="">
      {/* ราคาทองปัจจุบัน */}

      <Grid container spacing={2} className="mb-6">
        {/*  ทองรูปพรรณ */}
        <Grid item xs={12} md={6}>
          <Card className={'border border-yellow-500'}>
            <CardContent>
              <Typography
                variant="h6"
                className="mb-2 font-bold text-yellow-800"
              >
                ทองรูปพรรณ 96.5%
              </Typography>
              <Divider className="mb-3" />

              <div className="flex justify-between mb-2">
                <Typography variant="body1">ราคาซื้อคืน:</Typography>
                <Typography
                  variant="body1"
                  className="font-bold text-green-700"
                >
                  {sellPrice?.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) || ''}{' '}
                  /บาท
                </Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>

        {/* ทองแท่ง */}
        <Grid item xs={12} md={6}>
          <Card className={'border border-yellow-500'}>
            <CardContent>
              <Typography
                variant="h6"
                className="mb-2 font-bold text-yellow-800"
              >
                ทองแท่ง 96.5%
              </Typography>
              <Divider className="mb-3" />

              <div className="flex justify-between mb-2">
                <Typography variant="body1">ขายออก:</Typography>
                <Typography
                  variant="body1"
                  className="font-bold text-green-700"
                >
                  {goldPrice?.price?.gold_bar?.buy} / บาท
                </Typography>
              </div>

              <div className="flex justify-between">
                <Typography variant="body1">รับซื้อ:</Typography>
                <Typography variant="body1" className="font-bold text-red-700">
                  {goldPrice?.price?.gold_bar?.sell} / บาท
                </Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default GoldPrice2Form;
